// 3dfyrionvista.js (adaptado para incluir visor STL desde 3dfyrionstlprueba.js)

import React, { useState, lazy, Suspense } from 'react';
import StlViewer from './3dfyrionstlprueba'; // Asegúrate que esta ruta esté correcta


const VisorProducto = ({   imagenes, 
  imagenSeleccionada, 
  setImagenSeleccionada, 
  categoria, 
  producto, 
  linkstl, 
  modoVista, 
  setModoVista, 
  coloresGlobales, 
  setItemSeleccionado, 
  setTipoVarianteSeleccionada, 
  datosProducto  }) => {
    
    const styles = {
      contenedor: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
      },
      switchContenedor: {
        display: 'flex',
        border: '2px solid #0bbfe3',
        borderRadius: '30px',
        overflow: 'hidden',
        marginBottom: '20px',
        width: '250px',
        height: '40px',
        boxShadow: '0 2px 6px rgba(0, 0, 0, 0.1)',
      },
      switchBoton: (activo) => ({
        flex: 1,
        backgroundColor: activo ? '#0bbfe3' : '#fff',
        color: activo ? '#fff' : '#000',
        border: 'none',
        fontWeight: 'bold',
        fontSize: '14px',
        cursor: 'pointer',
        transition: 'background-color 0.3s, color 0.3s',
      }),
      visor: {
        width: '100%',
        maxWidth: '600px',
        borderRadius: '10px',
        overflow: 'hidden',
      },
      miniaturas: {
        display: 'flex',
        gap: '10px',
        marginTop: '10px',
        flexWrap: 'wrap',
        justifyContent: 'center',
      },
      miniatura: (seleccionada) => ({
        width: '60px',
        height: '70px',
        objectFit: 'cover',
        borderRadius: '5px',
        cursor: 'pointer',
        border: seleccionada ? '2px solid #0bbfe3' : '1px solid #ccc',
      }),
    };
  
    return (
      <div style={styles.contenedor}>
        {/* Switch de vista */}
        <div style={styles.switchContenedor}>
          <button
            onClick={() => setModoVista('imgs')}
            style={styles.switchBoton(modoVista === 'imgs')}
          >
            🖼️ Imgs
          </button>
          <button
            onClick={() => setModoVista('3d')}
            style={styles.switchBoton(modoVista === '3d')}
          >
            🌀 Vista 3D
          </button>
        </div>
  
        {/* Contenido según selección */}
        <div style={styles.visor}>
          {modoVista === 'imgs' ? (
            <>
              <img
                src={imagenSeleccionada}
                alt="Vista previa"
                style={{ width: '80%', borderRadius: '10px', objectFit: 'contain', maxWidth: '350px',}}
              />
              <div style={styles.miniaturas}>
                {imagenes.map((img, idx) => (
                  <img
  key={idx}
  src={img}
  alt={`Miniatura ${idx + 1}`}
  style={styles.miniatura(imagenSeleccionada === img)}
  onClick={() => {
    setImagenSeleccionada(img);

    // SINCRONIZAR VARIANTE CON LA IMG:
    const colorDetectado = Object.keys(coloresGlobales || {}).find(colorNombre => {
      const colorNormalizado = colorNombre.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().replace(/\s+/g, '');
      return img.toLowerCase().includes(colorNormalizado);
    });

    if (colorDetectado && datosProducto?.Variantes?.Color) {
      const variante = Object.values(datosProducto.Variantes.Color).find(v => {
        return v.Nombre.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().replace(/\s+/g, '') === colorDetectado.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().replace(/\s+/g, '');
      });

      if (variante) {
        setItemSeleccionado(variante);
        setTipoVarianteSeleccionada("Color");
      }

      const colorHex = coloresGlobales[variante.Nombre] ? `#${coloresGlobales[variante.Nombre]}` : null;
if (colorHex) {
  const colorFinal = { name: variante.Nombre, hex: colorHex };
  localStorage.setItem("colorSeleccionado", JSON.stringify(colorFinal));
  if (typeof window.onColorChangeStl === 'function') {
    window.onColorChangeStl(colorFinal);
  }
}

    }

  
    


  }}
/>
                ))}
              </div>
            </>
          ) : (
            <div style={{ height: '690px' }}>
              <StlViewer categoria={categoria} producto={producto} linkstl={linkstl } />

            </div>
          )}
        </div>
      </div>
    );
  };
  

export default VisorProducto;
